import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { SellersService } from 'app/providers/api/services';
import {
  UserRole,
  rolesPermittedToModifySeller,
} from 'shared/constants/userRole';
import { useApiQuery } from 'shared/hooks/useApiQuery';
import useAuth from 'shared/hooks/useAuth';
import { Seller } from 'shared/types/Sellers';

const useSellerPage = () => {
  const { sellerId } = useParams();
  const [sellerInfo, setSellerInfo] = useState<Seller | null>(null);
  const { userData } = useAuth();
  const userRoles: Array<UserRole> = userData?.roles;

  const { isLoading, refetch: refetchSellerInfo } = useApiQuery(
    ['getSeller', sellerId],
    () => SellersService.fetchSeller(sellerId),
    {
      onSuccess: (data) => {
        setSellerInfo(data);
      },
    },
  );

  const isPermittedToModifySeller = userRoles.some((role) =>
    rolesPermittedToModifySeller.includes(role),
  );

  return {
    isLoading,
    sellerInfo,
    refetchSellerInfo,
    isPermittedToModifySeller,
  };
};

export default useSellerPage;
